import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { Autocomplete, Popper, createFilterOptions, styled } from '@mui/material';
import TextField from '@mui/material/TextField';

const filter = createFilterOptions();

const StyledPopper = styled(Popper)(({ theme }) => ({
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
}));

export const SelectPipeline = observer(({ pipelines, showError, handleSelectedPipeline }) => {
  const [selectedPipeline, setSelectedPipeline] = useState(null);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    handleSelectedPipeline(selectedPipeline);
    setIsError(selectedPipeline === null || selectedPipeline === undefined);
  }, [selectedPipeline]);

  useEffect(() => {
    setIsError(showError);
  }, [showError]);

  useEffect(() => {
    document.querySelector('#select-pipeline-autocomplete fieldset').style.borderColor = isError
      ? '#ff0000'
      : 'rgba(0, 0, 0, 0.23)';
    document.querySelector('#select-pipeline-autocomplete label').style.color = isError
      ? '#ff0000'
      : 'rgba(0, 0, 0, 0.6)';
  }, [isError]);

  return (
    <>
      <div id="select-pipeline-autocomplete">
        <Autocomplete
          PopperComponent={StyledPopper}
          disablePortal
          id="select-pipeline-text"
          options={pipelines}
          size="small"
          renderOption={(props, option) => <li {...props}>{option.name}</li>}
          getOptionLabel={(option) => {
            return option.name;
          }}
          onChange={(event, newValue) => {
            setSelectedPipeline(newValue);
          }}
          renderInput={(params) => <TextField {...params} label="Select Pipeline" />}
        />
        <div
          id="pipeline-error-message"
          className={isError ? '' : 'lm-d-none'}
          style={{ margin: 0, fontSize: '12px', color: '#ff0000' }}
        >
          Please select a pipeline
        </div>
      </div>
    </>
  );
});
